import { CTAFlow } from './handler';

export const useCTAFlow = CTAFlow.getInstance;
